//ant design
import LoginModal from "./LoginModal";
import Vue from "vue";
Vue.component("login-modal", LoginModal);

new Vue({
  el: "#modal-login",
});
